import { currencyOptions } from "../../../constants";
export const buildCurrencyFormatter = (currencyCode, getCurrencyFormatter) => {
    const options = Object.assign(Object.assign({}, currencyOptions), { currency: currencyCode });
    return formatCurrency.bind(undefined, getCurrencyFormatter(options));
};
function formatCurrency(formatter, amount) {
    return formatter.format(amount);
}
//# sourceMappingURL=buildCurrencyFormatter.js.map